<template>
  <JqxWindow ref="myWindow" :theme="'material'" :width="1000" :height="720" :resizable="true" :isModal="true"
             :autoOpen="false">
    <div class="container">
      <div>
        <JqxSplitter ref="splitterspedizione" :width="width" :height="height" :autoCreate="true">
          <div class="splitter-panel" :theme="'material'">
            <div style="margin-top: 5px;margin-left: 5px;">
              <!--<div class="form-group">
                <label>Impianto depositante</label>
                <br>
                <JqxComboBox :autoDropDownHeight="true" :selectedIndex="0" ref="impianto_depositante"
                             :popupZIndex="10000" :displayMember="'ragione_sociale'"
                             :valueMember="'id'"
                             :source="dataAdapterImpianti" :theme="'material'"></JqxComboBox>
              </div>-->
              <div class="form-group">
                <label>Causale Trasporto</label>
                <br>
                <JqxDropDownList :autoDropDownHeight="true" :width="200" :height="25" :source="sourcecausale"
                                 :selectedIndex="0"
                                 :theme="'material'" ref="causale_trasporto"></JqxDropDownList>
              </div>

              <div class="form-group">
                <label>Aspetto Beni</label>
                <br>
                <JqxDropDownList :autoDropDownHeight="true" :selectedIndex="0"
                                 :popupZIndex="10000" :source="sourceaspettobeni"
                                 :theme="'material'" ref="aspetto_beni"></JqxDropDownList>
              </div>
              <div class="form-group">
                <label>Numero Beni</label>
                <br>
                <JqxInput :theme="'material'" ref="quantita_colli"></JqxInput>
              </div>
              <div class="form-group">
                <label>Peso (Kg)</label>
                <br>
                <JqxInput :theme="'material'" ref="peso_colli"></JqxInput>
              </div>
              <div class="form-group">
                <label>Contrassegno (€)</label>
                <br>
                <JqxInput :theme="'material'" ref="contrassegno"></JqxInput>
              </div>
            </div>
          </div>
          <div class="splitter-panel">
            <div style="margin-top: 5px;margin-left: 5px;">
              <div class="form-group">
                <label>Vettore</label>
                <br>
                <JqxComboBox :autoDropDownHeight="true" :selectedIndex="0"
                             :popupZIndex="0" :displayMember="'ragione_sociale'"
                             :valueMember="'id'"
                             :theme="'material'" ref="vettore" :source="dataAdapterVettori"></JqxComboBox>
              </div>
              <div class="form-group">
                <label>Porto</label>
                <br>
                <JqxDropDownList :autoDropDownHeight="true" :selectedIndex="0"
                                 :popupZIndex="10000" :source="sourceporto"
                                 :theme="'material'" ref="porto"></JqxDropDownList>
              </div>
              <div class="form-group">
                <label>N°DDT</label>
                <br>
                <JqxInput :theme="'material'" ref="numero_documento"></JqxInput>
              </div>
              <div class="form-group">
                <label>Destinazione Diversa</label>
                <br>
                <JqxTextArea :height="80" :theme="'material'" ref="destinazione_diversa"></JqxTextArea>
              </div>
              <div class="form-group">
                <label>Note</label>
                <br>
                <JqxTextArea :height="80" :theme="'material'" ref="note"></JqxTextArea>
              </div>
              <div class="form-group">
                <label>Note corriere</label>
                <br>
                <JqxTextArea :height="80" :theme="'material'" ref="note_corriere"></JqxTextArea>
              </div>
            </div>
          </div>

        </JqxSplitter>

      </div>
      <card>
        <div class="float-right">
          <JqxButton :theme="'material'" @click="saveParent">
            Save
          </JqxButton>

          <JqxButton :theme="'material'" @click="cancelParent">
            Cancel
          </JqxButton>
        </div>
      </card>
    </div>
  </JqxWindow>
</template>

<script>

  import JqxWindow from "~jqx/jqwidgets-vue/vue_jqxwindow.vue";
  import JqxButton from "~jqx/jqwidgets-vue/vue_jqxbuttons.vue";
  import JqxInput from "~jqx/jqwidgets-vue/vue_jqxinput.vue";
  import JqxTextArea from "~jqx/jqwidgets-vue/vue_jqxtextarea.vue";
  import JqxNumberInput from "~jqx/jqwidgets-vue/vue_jqxnumberinput.vue";
  import JqxCheckBox from "~jqx/jqwidgets-vue/vue_jqxcheckbox.vue";
  import JqxComboBox from "~jqx/jqwidgets-vue/vue_jqxcombobox.vue";
  import JqxDropDownList from "~jqx/jqwidgets-vue/vue_jqxdropdownlist.vue";
  import JqxSplitter from '~jqx/jqwidgets-vue/vue_jqxsplitter.vue';


  export default {
    name: "ArchivioSpedizioniEditDetails",
    components: {
      JqxInput,
      JqxNumberInput,
      JqxButton,
      JqxWindow,
      JqxCheckBox,
      JqxComboBox,
      JqxDropDownList,
      JqxSplitter,
      JqxTextArea
    },
    data: function () {
      return {
        dataAdapterImpianti: new jqx.dataAdapter(this.sourceanagraficaimpianti),
        dataAdapterVettori: new jqx.dataAdapter(this.sourceanagraficavettori),
        width: 850,
        height: 600,
        sourcecausale: [
          '',
          'Vendita',
          'Reso da conto deposito',
          'Trasferimento',],
        sourceaspettobeni: [
          '',
          'Bancale',
          'Cartoni',
          'Contenitori',
          'Pallet'
        ],
        sourceporto: [
          '',
          'Franco',
          'Assegnato',
        ]
      }
    }, beforeCreate: function () {
      this.sourceanagraficaimpianti = {
        datatype: 'json',
        datafields: [
          {name: 'ragione_sociale'},
          {name: 'id'},
        ],
        url: '/api/cruds/read?t=AnagraficaImpianti&q=allforsourceinput'
      };
      this.sourceanagraficavettori = {
        datatype: 'json',
        datafields: [
          {name: 'ragione_sociale'},
          {name: 'id'},
        ],
        url: '/api/cruds/read?t=AnagraficaVettori&q=allforsourceinput'
      };
    },
    methods: {
      saveParent() {
        this.$parent.saveBtn();
      },
      cancelParent() {
        this.$parent.cancelBtn();
      },
    }
  }
</script>

<style scoped>
  .jqx-splitter {
    border: none;
  }
</style>



// WEBPACK FOOTER //
// resources/js/components/cruddetails/ArchivioSpedizioniEditDetails.vue